<div class="loader plugin-section" [hidden]="status != LOADING">
  <div class="dimmed_outset">
    <core-title-section [title]="'Now viewing project <small>(# . . .)</small>'"></core-title-section>
  </div>
  <div class="dimmed dimmed_main">
    <div class="dimmed_content">
      <div class="dimmed_flex">
        <span class="dimmed_tag"></span>
        <span class="dimmed_tag"></span>
        <span class="dimmed_tag"></span>
      </div>
    </div>
  </div>
  <!-- <core-helpers-box-loading [hidden]="status != LOADING"></core-helpers-box-loading> -->
</div>

<core-helpers-box-http-error
  [hidden]="status != NOT_FOUND"
  [code]="404"
  [message]="'Not found'"
></core-helpers-box-http-error>

<section *ngIf="status == DONE" class="request-content apollo-main ">
  <div class="app-main">
    <div class="request-main">
      <header>
        <core-title-section-labels [text]="'Now viewing project <small>(#' + request.id+ ')</small>'" [labels]="request.labels"></core-title-section-labels>
      </header>
      <div class="sub-header">
        <div>
          <h3>File comparison</h3>
          <p>Here you can select the files to compare</p>
        </div>
        <div [hidden]="!files.isComplete()">
          <div class="fieldset-buttons">
            <core-helpers-forms-button
            [type]="'grey'"
            [text]="'Cancel'"
            (submit)="cancel()"
            ></core-helpers-forms-button>
            <core-helpers-forms-button-white
            [text]="'Compare'"
            (submit)="goToCompare()"
            ></core-helpers-forms-button-white>
          </div>
        </div>
      </div>
      <!-- -->
      <div class="two-boxes-plugin request-compare-files">
        <div>
          <!-- <core-file-selected-box
          [file]="files.reference"
          [title]="'YOUR REFERENCE'"
          [buttonAction]="files.isComplete()"
          [buttonActionText]="'CHANGE ORDER'"
          (onButtonActionClick)="files.changeOrder()"
          (onFileActionClick)="files.remove('reference')"
          ></core-file-selected-box> -->

          <core-files-selected-box
            [title]="'YOUR REFERENCE'"
            [files]="files.reference? [files.reference] : []"
            [buttonAction]="files.isComplete()"
            [buttonActionText]="'CHANGE ORDER'"
            (onButtonActionClick)="files.changeOrder()"
            (onFileActionClick)="files.remove('reference')"
          ></core-files-selected-box>
        </div>
        <div>
          <!-- <core-file-selected-box
          [file]="files.target"
          [title]="'YOUR TARGET'"
          (onFileActionClick)="files.remove('target')"
          ></core-file-selected-box> -->
          <core-files-selected-box
            [title]="'YOUR TARGET'"
            [files]="files.target? [files.target] : []"
            (onFileActionClick)="files.remove('target')"
          ></core-files-selected-box>
        </div>
      </div>

      <h4 class="h4_subtitle">Select the files to compare from the list below</h4>

      <core-commons-files-list-checkbox
      [url]="filesUrl"
      [counterPluralTitle]="'attachments'"
      [counterSingularTitle]="'attachment'"
      [selected]="files.selected"
      (selectedChange)="onChange($event);"
      [disabled] = "files.isComplete()"
      ></core-commons-files-list-checkbox>

      <core-versions-related-groups-files-list-checkbox
        [request]="request"
        [related]="related"
        [selected]="files.selected"
        (selectedChange)="onChange($event);"
        [disabled]="files.isComplete()"
      ></core-versions-related-groups-files-list-checkbox>

    </div>
  </div>
</section>
